// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.button-graph {
  display: flex;
  justify-content: space-between;
  margin: 0 0 10px 0;
}
.right-button-graph {
  display: flex;
  justify-content: space-between;
  margin: 0;
}
.relation-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.legend-hide-button {
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin: 0;
  cursor: pointer;
  color: var(--text-secondary);
  z-index: 1000;
  box-sizing: border-box;
  margin-inline-start: 2px;
}
.legend-hide-button:hover {
  background-color: #00000010 !important;
  color: var(--primary) !important;
  border-radius: 3px !important;
  z-index: 1000 !important;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/identify-module/component/GraphPanel.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AACJ;AAEA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AAAJ;AAGA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AADJ;AAIA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAFJ;AAKA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAHJ;AAKI;EACI,sCAAA;EACA,gCAAA;EACA,6BAAA;EACA,wBAAA;AAHR","sourcesContent":[".graph {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.button-graph {\n    display: flex;\n    justify-content: space-between;\n    margin: 0 0 10px 0;\n}\n\n.right-button-graph {\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.relation-item {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.legend-hide-button {\n    font-size: 16px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-items: center;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 auto;\n    margin: 0;\n    cursor: pointer;\n    color: var(--text-secondary);\n    z-index: 1000;\n    box-sizing: border-box;\n    margin-inline-start: 2px;\n\n    &:hover {\n        background-color: #00000010 !important;\n        color: var(--primary) !important;\n        border-radius: 3px !important;\n        z-index: 1000 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
